"use client";

import { c as _c } from "react/compiler-runtime";
import NFTImageBalance from "@/components/nft-image/NFTImageBalance";
import styles from "@/components/nft-image/NFTImage.module.scss";
import type { BaseRendererProps } from "@/components/nft-image/types/renderer-props";
import { withArweaveFallback } from "@/components/nft-image/utils/gateway-fallback";
import Image from "next/image";
import { Col } from "react-bootstrap";
function getSrc(nft: BaseRendererProps["nft"], showThumbnail: boolean, showOriginal: boolean): string {
  if (showThumbnail) {
    return nft.thumbnail;
  }
  if (!showOriginal && nft.scaled) {
    return nft.scaled;
  }
  return nft.image;
}
export default function NFTImageRenderer(props) {
  const $ = _c(27);
  const t0 = !!props.showThumbnail;
  const t1 = !!props.showOriginal;
  let t2;
  if ($[0] !== props.nft || $[1] !== t0 || $[2] !== t1) {
    t2 = getSrc(props.nft, t0, t1);
    $[0] = props.nft;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const src = t2;
  const shouldLazyLoad = !!props.showThumbnail || props.height === 300;
  const marginBottomClass = props.height === "full" ? "" : "mb-2";
  const t3 = `${marginBottomClass} text-center d-flex align-items-center justify-content-center ${styles.imageWrapper} ${props.heightStyle} ${props.bgStyle}`;
  let t4;
  if ($[4] !== t3) {
    t4 = t3.trim();
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = shouldLazyLoad ? "lazy" : "eager";
  const t6 = !shouldLazyLoad;
  const t7 = shouldLazyLoad ? "auto" : "high";
  const t8 = props.imageStyle;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      height: "auto",
      width: "auto",
      maxWidth: "100%",
      maxHeight: "100%"
    };
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const t10 = props.id ?? `image-${props.nft.id}`;
  const t11 = props.nft.name;
  let t12;
  if ($[7] !== props.nft) {
    t12 = withArweaveFallback(t13 => {
      const {
        currentTarget
      } = t13;
      if (currentTarget.src === props.nft.thumbnail) {
        currentTarget.src = props.nft.scaled ? props.nft.scaled : props.nft.image;
      } else {
        if (currentTarget.src === props.nft.scaled) {
          currentTarget.src = props.nft.image;
        } else {
          if ("metadata" in props.nft) {
            currentTarget.src = props.nft.metadata.image;
          }
        }
      }
    });
    $[7] = props.nft;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] !== props.imageStyle || $[10] !== props.nft.name || $[11] !== src || $[12] !== t10 || $[13] !== t12 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t13 = <Image loading={t5} priority={t6} width="0" height="0" fetchPriority={t7} unoptimized={true} className={t8} style={t9} id={t10} src={src} alt={t11} onError={t12} />;
    $[9] = props.imageStyle;
    $[10] = props.nft.name;
    $[11] = src;
    $[12] = t10;
    $[13] = t12;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== props.height || $[19] !== props.nft.contract || $[20] !== props.nft.id || $[21] !== props.showBalance) {
    t14 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[18] = props.height;
    $[19] = props.nft.contract;
    $[20] = props.nft.id;
    $[21] = props.showBalance;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14 || $[25] !== t4) {
    t15 = <Col xs={12} className={t4}>{t13}{t14}</Col>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t4;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
}